
export default function PresentationSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#3F3F3F] mb-6">
              Quem Somos
            </h2>
            <div className="space-y-6 text-base text-[#3F3F3F] leading-relaxed">
              <p>
                A P&P Engenharia e Arquitetura foi criada para oferecer soluções completas e inteligentes em projetos residenciais e comerciais de alto padrão.
              </p>
              <p>
                Com sede em São Paulo e atuação em diversos estados, é reconhecida pela capacidade de unir visão criativa e domínio técnico — entregando resultados concretos e exclusivos.
              </p>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/d814b1bd925f103666a48797aca068ff.png"
              alt="Equipe P&P trabalhando em projetos"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}